import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center text-center" data-testid="notfound-page">
      <Compass className="w-10 h-10 text-primary mb-4" strokeWidth={1.5} />
      <div className="overline mb-2">404 · Off the plot</div>
      <h1 className="text-3xl sm:text-4xl font-black tracking-tighter">Page not found</h1>
      <p className="text-muted-foreground mt-2 text-sm max-w-sm">The page you&apos;re looking for doesn&apos;t exist. Return to the dashboard to find any of our 12 calculators.</p>
      <Link to="/" className="mt-6 h-11 px-5 rounded-md bg-primary text-primary-foreground text-sm font-semibold" data-testid="notfound-home-link">Back to dashboard</Link>
    </div>
  );
}
